"use strict";

import React from 'react';

const OrderPaymentMethodDisplay = ({paymentMethod='', paymentDetails={}}) => {

    const paymentMethodDisplayText = {
        'CC': 'Credit Card',
        'ECHECK': 'E-check',
        'BILL': 'Bill',
        'PHONE': 'Phone in credit card',
    };

    if(!!paymentMethod)
    {
        return (
            <>
                Method: { paymentMethodDisplayText[paymentMethod] || '' }<br />
                {!!paymentDetails &&
                    <>
                        {paymentMethod === 'CC' &&
                            <div>
                                Type: {paymentDetails.cardType ?? ''}<br />
                                Last 4: {paymentDetails.lastFour ?? ''}<br />
                                Expiration: {paymentDetails.expirationMonth ?? ''}/{paymentDetails.expirationYear ?? ''}<br />
                            </div>
                        }
                        {paymentMethod === 'ECHECK' &&
                            <div>
                                Last 6: {(paymentDetails.echeckID ?? '').substring((paymentDetails.echeckID ?? '').length - 6)}<br />
                            </div>
                        }
                    </>
                }
            </>
        );
    }
    return null;
};

export default OrderPaymentMethodDisplay;